module.exports = "mat-hint {\n  color: red; }\n\n.valid {\n  background-color: #000000 !important; }\n"